<template>
  <div class="fixed">
    <v-alert
      :value="alert"
      color="success"
      class="my-0"
      icon="info"
      dismissible>
      <span @click="gotoNotification">{{alertMessage}}</span>
    </v-alert>
    <v-toolbar md10 class="white">
      <router-link to="/">
        <v-img class="header_logo" src="./static/img/Aula_Logo.svg" height="40" :contain="true"/>
      </router-link>
      <v-progress-linear
        :active="$store.getters.isLoading"
        :indeterminate="true"
        bottom
        color="primary accent-4"/>
      <v-spacer/>
      <LanguageMenu/>
      <Menu v-if="$auth.ready()"/>
    </v-toolbar>
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import LanguageMenu from '@/components/LanguageMenu'

export default {
  components: { Menu, LanguageMenu },
  data () {
    return {
      alert: false,
      alertMessage: '',
      alertPath: '/'
    }
  },
  methods: {
    gotoNotification () {
      this.alert = false
      this.$router.push({ path: this.alertPath })
    }
  },
  mounted () {
    document.addEventListener('messageReceived', (e) => {
      this.alertMessage = e.detail.title
      this.alertPath = e.detail.url
      this.alert = true
      setTimeout(() => {
        this.alert = false
      }, 10000)
    })
  }
}
</script>

<style scoped lang="scss">

.v-toolbar {
  box-shadow: none;
}

.v-progress-linear {
  position: absolute;
  bottom: -7px;
  left: 0;
  margin: 0;
}
</style>

